import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {SIDE_NAV_TITLES} from "../../../../common/it-constants";
import {convertToSnakeCase} from "../../../../common/it-utils";

@Component({
  selector: 'app-new-security-detail',
  templateUrl: './new-security-detail.component.html',
  styleUrls: ['./new-security-detail.component.scss']
})
export class NewSecurityDetailComponent implements OnInit {

  @Input() tableDataShow: string;
  @Input() fdeNewSecurityDetail: [];

  newSecurityKey = convertToSnakeCase(SIDE_NAV_TITLES.newSecurity);

  constructor() { }

  ngOnInit(): void {
  }

}
